import axiosInstance from './api';
import AuthService from './auth.service';
import TokenService from './token.service';
const setup = (store) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = TokenService.getLocalAccessToken();
      if (token) {
        config.headers['Authorization'] = 'Bearer ' + token;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    (res) => {
      return res;
    },
    async (err) => {
      const originalConfig = err.config;
      // Preventing infinite loop: must exempt BOTH the login endpoint
      // (/identity/v1/auth) AND the refresh endpoint itself
      // (/identity/v1/auth/refresh, called a few lines below) - only the
      // login one was ever actually listed here, despite the comment's
      // original intent covering "refresh request" too. A 401 from a
      // genuinely-expired refresh token (correct behavior after the
      // 2026-09-08 identity-svc fix that replaced a stray 500 there) used
      // to accidentally dodge this whole branch by returning 500 instead -
      // which happened to match neither the 401 nor 403 case below and so
      // silently fell through to a clean reject. Once that 500 became a
      // (correct) 401, THIS retry branch started firing on a failed
      // refresh's own response, re-attempting the refresh endpoint again,
      // which fails 401 again, forever - confirmed live 2026-09-10: over
      // 1,100 refresh attempts fired in ~6 seconds on a stale session,
      // pegging the transaction-history page on an infinite "Завантаження…"
      // spinner and hammering identity-svc with load. Both real endpoint
      // strings now exempted so a failed refresh is never itself retried,
      // regardless of which status code it fails with.
      if (
        originalConfig.url !== '/identity/v1/auth' &&
        originalConfig.url !== '/identity/v1/auth/refresh' &&
        err.response
      ) {
        // Access Token was expired
        if (err.response.status === 401 && !originalConfig._retry) {
          originalConfig._retry = true;
          if (!TokenService.getLocalAccessToken()) {
            return;
          }
          try {
            const rs = await axiosInstance.post('/identity/v1/auth/refresh', {
              refresh_token: TokenService.getLocalRefreshToken(),
            });
            const new_token = rs.data;

            store.dispatch('auth/refreshToken', new_token);

            TokenService.updateLocalToken(new_token);

            return axiosInstance(originalConfig);
          } catch (_error) {
            await AuthService.logout();
            return Promise.reject(_error);
          }
        } else if (err.response.status === 403) {
          if (!originalConfig._retry) {
            // First 403 error, retry with refreshed access token
            originalConfig._retry = 1;

            try {
              const rs = await axiosInstance.post('/identity/v1/auth/refresh', {
                refresh_token: TokenService.getLocalRefreshToken(),
              });
              const new_token = rs.data;

              store.dispatch('auth/refreshToken', new_token);

              TokenService.updateLocalToken(new_token);

              return axiosInstance(originalConfig);
            } catch (error) {
              return Promise.reject(error);
            }
          } else if (originalConfig._retry === 1) {
            // Second 403 error, show notification
            originalConfig._retry = 2;

            return Promise.reject(err);
          }
        }
      }
      return Promise.reject(err);
    }
  );
};

export default setup;
